module.exports = __webpack_public_path__ + "static/media/documentView.a2746d09.svg";